<div class="my-layout my-layout-embedded">
  <div class="my-layout-content">
    <router-outlet></router-outlet>
  </div>
</div>
